import { Navigate } from "react-router-dom";

// Função para decodificar JWT e verificar expiração
const isTokenExpired = (token: string): boolean => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp;
    if (!exp) return true;
    
    // Verifica se expirou (com margem de 30 segundos)
    return Date.now() >= (exp * 1000) - 30000;
  } catch {
    return true;
  }
};

const AdminProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const adminToken = localStorage.getItem("admin_token");
  
  // Sem token = redireciona para login
  if (!adminToken) {
    return <Navigate to="/admin/login" replace />;
  }
  
  // Token expirado = limpa e redireciona
  if (isTokenExpired(adminToken)) {
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_user");
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

export default AdminProtectedRoute;

